/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_UnconfirmedInputs */

const en_admin_dashboard_unconfirmed = /** @type {(inputs: Admin_Dashboard_UnconfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`unconfirmed`)
};

const de_admin_dashboard_unconfirmed = /** @type {(inputs: Admin_Dashboard_UnconfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`unbestätigt`)
};

const es_admin_dashboard_unconfirmed = /** @type {(inputs: Admin_Dashboard_UnconfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`no confirmado`)
};

const fr_admin_dashboard_unconfirmed = /** @type {(inputs: Admin_Dashboard_UnconfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`non confirmé`)
};

const nl_admin_dashboard_unconfirmed = /** @type {(inputs: Admin_Dashboard_UnconfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`niet bevestigd`)
};

const it_admin_dashboard_unconfirmed = /** @type {(inputs: Admin_Dashboard_UnconfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`non confermato`)
};

const pt_br2_admin_dashboard_unconfirmed = /** @type {(inputs: Admin_Dashboard_UnconfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`não confirmados`)
};

const pl_admin_dashboard_unconfirmed = /** @type {(inputs: Admin_Dashboard_UnconfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nie potwierdzono`)
};

const hu_admin_dashboard_unconfirmed = /** @type {(inputs: Admin_Dashboard_UnconfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nincs megerősítve`)
};

const ro_admin_dashboard_unconfirmed = /** @type {(inputs: Admin_Dashboard_UnconfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`neconfirmat`)
};

/**
* | output |
* | --- |
* | "unconfirmed" |
*
* @param {Admin_Dashboard_UnconfirmedInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_unconfirmed = /** @type {((inputs?: Admin_Dashboard_UnconfirmedInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_UnconfirmedInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_unconfirmed(inputs)
	if (locale === "de") return de_admin_dashboard_unconfirmed(inputs)
	if (locale === "es") return es_admin_dashboard_unconfirmed(inputs)
	if (locale === "fr") return fr_admin_dashboard_unconfirmed(inputs)
	if (locale === "nl") return nl_admin_dashboard_unconfirmed(inputs)
	if (locale === "it") return it_admin_dashboard_unconfirmed(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_unconfirmed(inputs)
	if (locale === "pl") return pl_admin_dashboard_unconfirmed(inputs)
	if (locale === "hu") return hu_admin_dashboard_unconfirmed(inputs)
	return ro_admin_dashboard_unconfirmed(inputs)
});
export { admin_dashboard_unconfirmed as "admin.dashboard.unconfirmed" }